import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdatePublicationCommentListQuery } from "@/queries/query-publication-comment";

export const useRemoveCommentMessage = (publicationId: string) => {
  const update = useUpdatePublicationCommentListQuery(publicationId);

  return useMutationWithErrorHandler(
    async ({ commentId, messageIndex }: { commentId: string; messageIndex: number }) => {
      const message = await getRanaApiV1().PublicationCommentsApi.commentDeleteMessage({
        publicationId,
        commentId,
        messageIndex,
      });

      await update(message.id, message);
    }
  );
};
